import { useState } from 'react';

const faqData = [
  {
    question: '亚洲自拍和欧美自拍有什么主要区别？',
    answer: '亚洲自拍更注重皮肤质感的呈现，追求"水光肌"般的通透感，色调偏向柔和温暖。而欧美自拍通常更强调轮廓感和立体感，色调对比度更高。此外，亚洲自拍更喜欢使用美颜滤镜来优化皮肤细节，而欧美自拍则更倾向于保留自然肤质。',
  },
  {
    question: '新手自拍最应该先学什么？',
    answer: '新手自拍最应该先学习三个基础技能：第一是光线利用，学会找到柔和均匀的正面光源；第二是构图基础，掌握三分法和中央对称两种最基本也最实用的构图方式；第三是角度选择，找到最适合自己脸型的拍摄角度。这三样基本功扎实了，自拍水平自然就会大幅提升。',
  },
  {
    question: '什么手机最适合拍自拍？',
    answer: '2026年适合自拍的手机，建议关注以下几个关键参数：前置摄像头像素不低于2000万、支持自动对焦、光圈在f/2.0及以上。具体型号方面，旗舰机型的前置拍摄效果普遍出色，而3000-5000元价位的中端机型在自拍方面也有了质的飞跃，性价比更高。',
  },
  {
    question: '自拍时如何选择合适的滤镜？',
    answer: '选择滤镜的核心原则是"适合自己肤色"。亚洲肤色偏黄，建议选择暖色调滤镜来中和肤色，避免使用过于冷调或高对比度的滤镜。韩系滤镜是亚洲自拍的不错选择，其清透柔和的色调非常适合亚洲肤色。另外，滤镜强度建议控制在50%以下，保持自然感。',
  },
  {
    question: '室内自拍光线不够怎么办？',
    answer: '室内自拍光线不足时，有几种解决方案：一是利用窗边的自然光，面朝窗户拍摄；二是投资一个环形灯，价格从200元起就能买到不错的产品；三是使用手机自带的屏幕补光功能；四是在台灯前加一层白色薄布来柔化光线。最经济有效的方法是充分利用自然光。',
  },
  {
    question: '网红自拍风格应该怎么学习？',
    answer: '学习网红自拍风格，建议从三个方面入手：首先关注你喜欢的网红，分析她们自拍的共同特点（角度、光线、滤镜、场景）；其次选择一个风格进行模仿练习，不要同时尝试多种风格；最后在模仿的基础上加入自己的特点，逐步形成独特的个人风格。小红书和抖音上有大量的教程可以参考。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-100 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-400 text-sm md:text-base">
            关于亚洲自拍，你最关心的问题都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="font-heading text-sm md:text-base font-medium text-foreground-100 pr-4">
                  {faq.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${openIndex === index ? 'subtract-line' : 'add-line'} text-foreground-400 transition-transform duration-300`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-400 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}